import axios, { AxiosRequestConfig } from 'axios';
import { ExerciseLogProps } from './types';
import { clearSessionCredentials } from '../../../globalFunctions';
import { NavigateFunction } from 'react-router-dom';
import { Exercise } from '../../../types';



export const saveExerciseChanges = async (
    token: string,
    exercise,
    navigate: NavigateFunction
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/exercise/${exercise.id}`,
            exercise,
            requestConfig
        );

        return true;
    } catch (error: any) {
        const response = {
            message: 'Erro ao salvar alterações dos exercícios',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
           // clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return false;
        }
    }
};

export const createExerciseLog = async (
    token: string,
    navigate: NavigateFunction,
    log: ExerciseLogProps
) => {
    try {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${token}`,
                Accept: 'application/json'
            }
        };

        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/trilogic/registers`,
            log,
            requestConfig
        );

        return response.data;
    } catch (error: any) {
        const response = {
            message: 'Erro ao registrar jogada',
            error: error
        };

        if ([401, 419].includes(error.response.status)) {
            // Unauthorized
            clearSessionCredentials(navigate);
        } else {
            console.error(response);
            return response;
        }
    }
};
